/**
 * Created by Mark on 18/04/2017.
 */


import ENVIRONMENT_CONSTANTS from './environment.js'

export default {
    GET_ALL_ACCOUNT : ENVIRONMENT_CONSTANTS.BASE_URL + '/medalsController/getAllForAccount',
    UPDATE_ACCOUNT_MEDALS:'UPDATE_ALL_MEDALS' ,
    GET_ALL_CLASS : ENVIRONMENT_CONSTANTS.BASE_URL + '/medalsController/getClass',
    GET_STUDENT_TOTAL : ENVIRONMENT_CONSTANTS.BASE_URL + '/medalsController/getStudent',
    UPDATE_CLASS_MEDALS_LEVEL : "UPDATE_CLASS_MEDALS_LEVEL",
    UPDATE_STUDENT_MEDALS_TOTAL:"UPDATE_STUDENT_MEDALS_TOTAL"
}



// WEBPACK FOOTER //
// ./src/constants/medals.js